import { t } from '../i18nService';

function setStream(video, stream) {
    if (typeof video === 'object' && video && video.srcObject !== stream) {
        video.srcObject = stream;
        video.play();
        return true;
    }

    return false;
}

function mapPropsToProps({ alreadyCaptured }) {
    const buttonLabelKey = alreadyCaptured
        ? 'idVerification.captureDevice.retakePhoto'
        : 'idVerification.captureDevice.takePhoto';

    const ariaLabelKey = alreadyCaptured
        ? 'idVerification.captureDevice.retakePhotoAriaLabel'
        : 'idVerification.captureDevice.takePhotoAriaLabel';

    return {
        buttonLabel: t(buttonLabelKey),
        ariaLabel: t(ariaLabelKey),
    };
}

export {
    mapPropsToProps,
    setStream,
};
